export const PHONE_REGEX = "^([0-9]{3})-([0-9]{3})-([0-9]{4})$";

let loginLink = "https://www.connectcdk.com/a/";
if (process.env.NODE_ENV === "development") {
  loginLink = "https://www-dit.connectcdk.com/a/";
}

let cvrLoginLink = "https://access.cvrconnect.com/a/";
if (process.env.NODE_ENV === "development") {
  cvrLoginLink = "https:/access-dev.cvrconnect.com/a/";
}

export const LOGIN_LINK = loginLink + "hub/";
export const CVR_LOGIN_LINK = cvrLoginLink + "hub/";
export const PARTNER_LOGIN_LINK = loginLink + "partnerhub/";
